import { createTranslationRef } from '@backstage/core-plugin-api/alpha';

const searchReactTranslationRef = createTranslationRef({
  id: "search-react",
  messages: {
    searchBar: {
      title: "Search",
      placeholder: "Search in {{org}}"
    },
    searchFilter: {
      allOptionTitle: "All"
    },
    searchPagination: {
      limitLabel: "Results per page:",
      limitText: "of {{num}}"
    },
    noResultsDescription: "Sorry, no results were found",
    searchResultGroup: {
      linkTitle: "See All",
      addFilterButtonTitle: "Add filter"
    },
    searchResultPager: {
      previous: "Previous",
      next: "Next"
    }
  }
});

export { searchReactTranslationRef };
//# sourceMappingURL=translation.esm.js.map
